import React from "react";

const DotedPart = (props) => {
  return (
    <>
      <div className={`${props.className}`}>
        <div className="flex justify-center overflow-hidden mb-[20px]">
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
        </div>
        <div className="flex justify-center overflow-hidden my-[20px]">
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
        </div>
        <div className="flex justify-center overflow-hidden my-[20px]">
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
        </div>
        <div className="flex justify-center overflow-hidden mt-[20px]">
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#3359D3] mx-[20px]"></div>
          <div className="h-[6px] min-w-[6px] rounded bg-[#D9D9D9] mx-[20px]"></div>
        </div>
      </div>
    </>
  );
};

export default DotedPart;
